import { Route } from "react-router-dom";
import { ProtectedRoute } from "../components/Atoms/ProtectedRoute";
import { ProtectedAdminRoute } from "../components/Atoms/ProtectedAdminRoute";
import { Concessionaire } from "../components/Pages/Concessionaire";
import { Concessionaires } from "../components/Pages/Concessionaires";
import { LayoutTemplate } from "../components/Templates/LayoutTemplate";
import { AdminStores } from "../components/Pages/AdminStores";
import { AdminStoresRegister } from "../components/Pages/AdminStoresRegister";
import { AdminStoreDetail } from "../components/Pages/AdminStoreDetail";
import { Settings } from "../components/Pages/Settings";
import { Holidays } from "../components/Pages/Holidays";
import { HolidaysRegister } from "../components/Pages/HolidaysRegister";
import { Itinerants } from "../components/Pages/Itinerants";
import { ItinerantRegister } from "../components/Pages/ItinerantRegister";
import { ItinerantDetail } from "../components/Pages/ItinerantDetail";
import { ItinerantReschedule } from "../components/Pages/ItinerantReschedule";
import { AdminDeliverys } from "../components/Pages/AdminDeliverys";
import { AdminDeliveryRegister } from "../components/Pages/AdminDeliveryRegister";
import { AdminDeliveryDetail } from "../components/Pages/AdminDeliveryDetail";
import { Collaborators } from "../components/Pages/Collaborators";
import { CollaboratorRegister } from "../components/Pages/CollaboratorRegister";
import { CollaboratorDetail } from "../components/Pages/CollaboratorDetail";
import { Clients } from "../components/Pages/Clients";
import { ClientRegister } from "../components/Pages/ClientRegister";
import { ClientDetail } from "../components/Pages/ClientDetail";
import { Profiles } from "../components/Pages/Profiles";
import { ProfilesRegister } from "../components/Pages/ProfilesRegister";
import { ProfilesDetail } from "../components/Pages/ProfilesDetail";

export const useSettingsRoutes = () => {
  return (
    <Route path="/configuracoes">
      <Route index element={<Settings />} />

      <Route path="/configuracoes/concessionarias" element={<LayoutTemplate />}>
        <Route
          index
          element={
            <ProtectedRoute>
              <ProtectedAdminRoute>
                <Concessionaires />
              </ProtectedAdminRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="concessionaria"
          element={
            <ProtectedRoute>
              <ProtectedAdminRoute>
                <Concessionaire />
              </ProtectedAdminRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="cadastro"
          element={
            <ProtectedRoute>
              <ProtectedAdminRoute>
                <Concessionaire />
              </ProtectedAdminRoute>
            </ProtectedRoute>
          }
        />
      </Route>

      <Route path="/configuracoes/lojas" element={<LayoutTemplate />}>
        <Route index element={<AdminStores />} />
        <Route
          path="/configuracoes/lojas/cadastro"
          element={<AdminStoresRegister />}
        />

        <Route
          path="/configuracoes/lojas/detalhe"
          element={<AdminStoreDetail />}
        />
      </Route>

      <Route path="/configuracoes/deliverys" element={<LayoutTemplate />}>
        <Route index element={<AdminDeliverys />} />
        <Route path="cadastro" element={<AdminDeliveryRegister />} />
        <Route path="detalhe" element={<AdminDeliveryDetail />} />
      </Route>

      <Route path="/configuracoes/feriados" element={<LayoutTemplate />}>
        <Route index element={<Holidays />} />
        <Route
          path="/configuracoes/feriados/cadastro"
          element={<HolidaysRegister />}
        />
      </Route>

      <Route path="/configuracoes/itinerantes" element={<LayoutTemplate />}>
        <Route index element={<Itinerants />} />
        <Route
          path="/configuracoes/itinerantes/cadastro"
          element={<ItinerantRegister />}
        />
        <Route
          path="/configuracoes/itinerantes/detalhe"
          element={<ItinerantDetail />}
        />
        <Route
          path="/configuracoes/itinerantes/reagendamento"
          element={<ItinerantReschedule />}
        />
      </Route>

      <Route path="/configuracoes/perfis" element={<LayoutTemplate />}>
        <Route index element={<Profiles />} />
        <Route path="cadastro" element={<ProfilesRegister />} />
        <Route path="detalhe" element={<ProfilesDetail />} />
      </Route>
      <Route path="/configuracoes/colaboradores" element={<LayoutTemplate />}>
        <Route index element={<Collaborators />} />
        <Route path="cadastro" element={<CollaboratorRegister />} />
        <Route path="detalhe" element={<CollaboratorDetail />} />
      </Route>

      <Route path="/configuracoes/clientes" element={<LayoutTemplate />}>
        <Route index element={<Clients />} />
        <Route path="cadastro" element={<ClientRegister />} />
        <Route path="detalhe" element={<ClientDetail />} />
      </Route>
    </Route>
  );
};
